/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WYSIWYGTextareaWithFeatureFlag_organization$ref: FragmentReference;
declare export opaque type WYSIWYGTextareaWithFeatureFlag_organization$fragmentType: WYSIWYGTextareaWithFeatureFlag_organization$ref;
export type WYSIWYGTextareaWithFeatureFlag_organization = {|
  +databaseId: string,
  +isWysiwygEnabled: boolean,
  +$refType: WYSIWYGTextareaWithFeatureFlag_organization$ref,
|};
export type WYSIWYGTextareaWithFeatureFlag_organization$data = WYSIWYGTextareaWithFeatureFlag_organization;
export type WYSIWYGTextareaWithFeatureFlag_organization$key = {
  +$data?: WYSIWYGTextareaWithFeatureFlag_organization$data,
  +$fragmentRefs: WYSIWYGTextareaWithFeatureFlag_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WYSIWYGTextareaWithFeatureFlag_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWysiwygEnabled",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '1ac80c492de339170f27c1b204c32ec5';

module.exports = node;
